import React from "react"
import { Dropdown } from "../Dropdown"
import NavbarTopicsToggle from "./NavbarTopicsToggle"
import TopicsDropdown from "../TopicsDropdown"

export default function NavbarTopicsDropdown({ id, className }) {
  return (
    <Dropdown
      id={id}
      toggle={({ isOpen, toggle }) => (
        <NavbarTopicsToggle
          className={className}
          active={isOpen}
          onClick={toggle}
        />
      )}
      menuClassName="topics-dropdown"
      menuAlignRight
    >
      {({ isOpen, close }) => <TopicsDropdown close={close} />}
    </Dropdown>
  )
}